import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  Grid,
  Button,
  CircularProgress,
  Card,
  CardContent,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import { solicitudDetalleService } from '../../services';

const SeccionTerminosCondiciones = ({ solicitudId, tipo }) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formData, setFormData] = useState({
    aceptaTerminosCondiciones: false,
    aceptaReglamentoGestionFondos: false,
    aceptaComisiones: false
  });

  const cargarDatos = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const getMethod = tipo === 'individuo'
        ? solicitudDetalleService.getTerminosCondicionesIndividuo
        : solicitudDetalleService.getTerminosCondicionesEmpresa;
      const response = await getMethod(solicitudId);
      if (response) {
        setFormData({
          aceptaTerminosCondiciones: response.aceptaTerminosCondiciones || false,
          aceptaReglamentoGestionFondos: response.aceptaReglamentoGestionFondos || false,
          aceptaComisiones: response.aceptaComisiones || false
        });
      }
    } catch (err) {
      setError('Error al cargar los términos y condiciones');
    } finally {
      setLoading(false);
    }
  }, [solicitudId, tipo]);

  useEffect(() => {
    cargarDatos();
  }, [cargarDatos]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');

    try {
      const datosParaGuardar = {
        solicitudId: parseInt(solicitudId),
        ...formData
      };
      const saveMethod = tipo === 'individuo'
        ? solicitudDetalleService.saveTerminosCondicionesIndividuo
        : solicitudDetalleService.saveTerminosCondicionesEmpresa;
      await saveMethod(datosParaGuardar);
      setSuccess('Datos guardados exitosamente');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Error al guardar los datos');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Términos y Condiciones
        </Typography>
        {error && (
          <Box p={2} mb={2} style={{ backgroundColor: '#ffebee', color: '#c62828', borderRadius: '4px' }}>
            <Typography variant="body2">{error}</Typography>
          </Box>
        )}
        {success && (
          <Box p={2} mb={2} style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', borderRadius: '4px' }}>
            <Typography variant="body2">{success}</Typography>
          </Box>
        )}
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.aceptaTerminosCondiciones}
                    onChange={(e) => handleInputChange('aceptaTerminosCondiciones', e.target.checked)}
                  />
                }
                label="Acepta Términos y Condiciones"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.aceptaReglamentoGestionFondos}
                    onChange={(e) => handleInputChange('aceptaReglamentoGestionFondos', e.target.checked)}
                  />
                }
                label="Acepta Reglamento de Gestión de Fondos"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.aceptaComisiones}
                    onChange={(e) => handleInputChange('aceptaComisiones', e.target.checked)}
                  />
                }
                label="Acepta Comisiones"
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={saving}
              >
                {saving ? <CircularProgress size={20} /> : 'Guardar'}
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
};

export default SeccionTerminosCondiciones;

